import axios from 'axios';
import { BASE_URL, VENDOR_NOTIFICATION_EMAIL_API_PATH } from '../../../constants/api';
import { FetchResult } from '../../type/apiType';
import {
  VendorNotificationEmailCreateRequest,
  VendorNotificationEmailQueryParams,
  VendorNotificationEmailRow,
} from '../../type/vendorNotificationEmailType';
import { ApiService } from './apiService';

class VendorNotificationEmailApiService extends ApiService<VendorNotificationEmailRow> {
  constructor() {
    super(VENDOR_NOTIFICATION_EMAIL_API_PATH);
  }

  public async fetchList(
    params?: VendorNotificationEmailQueryParams
  ): Promise<FetchResult<VendorNotificationEmailRow>> {
    const response = await axios.get(`${BASE_URL}${VENDOR_NOTIFICATION_EMAIL_API_PATH}`, {
      params,
    });
    return response.data;
  }

  public async createEmail(
    body: VendorNotificationEmailCreateRequest
  ): Promise<VendorNotificationEmailRow> {
    const response = await axios.post(`${BASE_URL}${VENDOR_NOTIFICATION_EMAIL_API_PATH}`, body);
    return response.data;
  }

  public async deleteEmail(id: number): Promise<void> {
    await axios.delete(`${BASE_URL}${VENDOR_NOTIFICATION_EMAIL_API_PATH}${id}/`);
  }
}

export const vendorNotificationEmailApiService = new VendorNotificationEmailApiService();
